/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { ThemeContext } from "contexts/ThemeContext"
import { THEME_COLORS, TIMEOUT } from "utils/constants"
import { Footer, Header } from "components"
import styles from "./layout.module.scss"
import "styles/index.scss"

let THEME = THEME_COLORS[Math.floor(Math.random() * THEME_COLORS.length)]

const Layout = ({ children }) => {
  const [pageLoaded, setPageLoaded] = useState(false)
  const [themeColor, setThemeColor] = useState({
    theme: THEME.color1,
    spot: THEME.color2,
  })

  const themeStyle = {
    "--theme": themeColor.theme,
    "--spot": themeColor.spot,
  }

  const changeColor = () => {
    THEME = THEME_COLORS[Math.floor(Math.random() * THEME_COLORS.length)]
    setThemeColor({ theme: THEME.color1, spot: THEME.color2 })
  }

  useEffect(() => {
    setPageLoaded(true)

    setInterval(() => {
      changeColor()
    }, TIMEOUT)
  }, [])

  return (
    <>
      {pageLoaded && (
        <Helmet
          htmlAttributes={{ style: `background-color: ${THEME.color1}` }}
        />
      )}
      <main className={styles.main} style={themeStyle}>
        <Header />
        <ThemeContext.Provider
          value={{ spot: THEME.color2, changeColor: changeColor }}
        >
          {children}
        </ThemeContext.Provider>
        <Footer />
      </main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
